
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckChangeProjects/CheckChangeProjects.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckChangeProjects.html');
        
        var script = require('./CheckChangeProjects.ts').default;
        module.exports = require('./CheckChangeProjects.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    